import { MaintenancePageCombinedProps } from './types';

const usePresenter = (props: MaintenancePageCombinedProps): MaintenancePageCombinedProps => {
  return props;
};

export default usePresenter;
